"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _concatInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/concat");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getCurrentUserRequestFailed = exports.getCurrentUserRequest = exports.getCurrentUserEpic = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _connectedReactRouter = require("connected-react-router");

var _Observable = require("rxjs/Observable");

var _operators = require("rxjs/operators");

var _mergeMap = require("rxjs/operators/mergeMap");

var _auth = require("../../../auth");

var _ILoading = require("../../../models/ILoading");

var _createAjaxEpic = require("../../../redux/createAjaxEpic");

var _Telemetry = require("../../../telemetry/Telemetry");

var _UserActions = require("../../models/UserActions");

var _userRegistry = require("../userRegistry");

var getCurrentUserEpic = function getCurrentUserEpic(action$) {
  return action$.ofType(_UserActions.UserActions.getMyUserRequest).pipe((0, _mergeMap.mergeMap)(function () {
    return processAuthState((0, _auth.getUserAuth)());
  }));
};

exports.getCurrentUserEpic = getCurrentUserEpic;

_userRegistry.userRegistry.addEpic(_UserActions.UserActions.getMyUserRequest, getCurrentUserEpic);

var getCurrentUserRequest = function getCurrentUserRequest(state, action) {
  var auth = action.payload;

  if (!auth) {
    return state;
  }

  if (auth.profile) {
    _Telemetry.telemetry.setActorObjectId(auth.profile.oid);

    _Telemetry.telemetry.setActorTenantId(auth.profile.tid);
  }

  var nextState = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    auth: auth,
    // If the user is not authenticated, then we should remain in the loading state
    isLoading: false,
    loadingState: _ILoading.LoadingState.loaded
  });
  return nextState;
};

exports.getCurrentUserRequest = getCurrentUserRequest;

_userRegistry.userRegistry.add((0, _createAjaxEpic.getSuccessActionType)(_UserActions.UserActions.getMyUserRequest), getCurrentUserRequest);

var getCurrentUserRequestFailed = function getCurrentUserRequestFailed(state, action) {
  var auth = action.payload;

  if (!auth) {
    return state;
  }

  if (auth.profile) {
    _Telemetry.telemetry.setActorObjectId(auth.profile.oid);

    _Telemetry.telemetry.setActorTenantId(auth.profile.tid);
  }

  var nextState = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    auth: auth,
    // If the user is not authenticated, then we should remain in the loading state
    isLoading: true,
    loadingState: _ILoading.LoadingState.error,
    loadingError: auth.loginError ? new Error(auth.loginError) : undefined
  });
  return nextState;
};

exports.getCurrentUserRequestFailed = getCurrentUserRequestFailed;

_userRegistry.userRegistry.add((0, _createAjaxEpic.getFailureActionType)(_UserActions.UserActions.getMyUserRequest), getCurrentUserRequestFailed);

var processAuthState = function processAuthState(auth) {
  var urlToRestoreAfterLogin = auth.loginRedirect;

  if (auth.loginError) {
    return _Observable.Observable.of({
      type: (0, _createAjaxEpic.getFailureActionType)(_UserActions.UserActions.getMyUserRequest),
      payload: auth
    });
  } else if (!auth.isAuthenticated) {
    return _Observable.Observable.of({
      type: _UserActions.UserActions.getMyUserLoginRequired,
      payload: auth
    });
  } else {
    var loginSuccess = _Observable.Observable.of({
      type: (0, _createAjaxEpic.getSuccessActionType)(_UserActions.UserActions.getMyUserRequest),
      payload: auth
    });

    if (urlToRestoreAfterLogin) {
      // Set the location to be the url to restore after login before doing the success action
      loginSuccess = _Observable.Observable.of((0, _connectedReactRouter.replace)(urlToRestoreAfterLogin)).pipe((0, _concatInstanceProperty(_operators))(loginSuccess));
    }

    return loginSuccess;
  }
};